import { render, staticRenderFns } from "./PanelCard.vue?vue&type=template&id=76054b19&scoped=true"
import script from "./PanelCard.vue?vue&type=script&lang=js"
export * from "./PanelCard.vue?vue&type=script&lang=js"
import style0 from "./PanelCard.vue?vue&type=style&index=0&id=76054b19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76054b19",
  null
  
)

export default component.exports